import type { AuthConfig } from './types';

// Any value other than the string 'false' means auth is enabled (default: true).
export const isAuthEnabled: boolean =
  process.env.REACT_APP_AUTH_ENABLED !== 'false';

/**
 * Returns the access_token value from the URL if present (case-insensitive),
 * or null otherwise. When set, SSO is skipped and auth is delegated to the backend.
 */
export const getUrlAccessToken = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  for (const [key, value] of params.entries()) {
    if (key.toLowerCase() === 'access_token') return value;
  }
  return null;
};

export const hasUrlAccessToken = (): boolean => getUrlAccessToken() !== null;

function requireEnv(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export function getAuthConfig(): AuthConfig {
  if (!isAuthEnabled) {
    // Return a no-op config so callers don't throw when Cognito vars are absent.
    return {
      clientId: '',
      cognitoDomain: '',
      logoutRedirectUri: '',
      redirectUri: '',
      responseType: 'code',
    };
  }
  return {
    clientId: requireEnv('REACT_APP_COGNITO_CLIENT_ID'),
    cognitoDomain: requireEnv('REACT_APP_COGNITO_DOMAIN'),
    logoutRedirectUri: requireEnv('REACT_APP_COGNITO_LOGOUT_REDIRECT_URI'),
    redirectUri: requireEnv('REACT_APP_COGNITO_REDIRECT_URI'),
    responseType: 'code',
  };
}
